import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'

import { httpOk, GET } from 'helpers/api'
import { formatMoney, returnSign } from "helpers/helpers"

function SummaryIncomes({ setActiveModal, filterData }) {
	const { t } = useTranslation()

	const [data, setData] = useState([])

	async function searchWithFilter() {
		var filterUrl = "/report-summary-incomes"
		var urlParams = ""

		if (filterData.pos_id)
			urlParams += returnSign(urlParams) + 'pos_id=' + filterData.pos_id
		if (filterData.start_date)
			urlParams += returnSign(urlParams) + 'start_date=' + filterData.start_date
		if (filterData.end_date)
			urlParams += returnSign(urlParams) + 'end_date=' + filterData.end_date

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) setData(response.data)
	}

	useEffect(() => {
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<Modal
				show={true}
				animation={false}
				centered
				size="lg"
				onHide={() => setActiveModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{t('good_reception')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="table-responsive table-fixed" style={{ 'height': '500px', 'overflow': 'auto' }}>
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '40%' }}>{t('supplier')}</th>
									<th className="text-end" style={{ 'width': '20%' }}>{t('debt')}</th>
									<th className="text-end" style={{ 'width': '20%' }}>{t('amortization')}</th>
									<th className="text-end" style={{ 'width': '20%' }}>{t('total')}</th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{index + 1}</td>
										<td>{item.name}</td>
										<td className="text-danger text-end">{formatMoney(item.amount_out)}</td>
										<td className="text-success text-end">{formatMoney(item.amount_in)}</td>
										<td className={`text-danger text-end ${item.debt_now > 0 ? 'text-success' : 'text-danger'}`}>
											{formatMoney(item.debt_now)}
										</td>
									</tr>
								))}
								<tr>
									<td></td>
									<td><b>{t('total')}</b></td>
									<td className="text-danger text-end"><b>{formatMoney(data.total_amount_out)}</b></td>
									<td className="text-success text-end"><b>{formatMoney(data.total_amount_in)}</b></td>
									<td className={`text-danger text-end ${data.debt_now > 0 ? 'text-success' : 'text-danger'}`}><b>{formatMoney(data.total_debt_now)}</b></td>
								</tr>
							</tbody>
						</table>
					</div>
				</Modal.Body>
			</Modal>
		</>
	)
}

export default SummaryIncomes